import { observer } from 'mobx-react-lite'
import React from 'react'
import { Button, EnumHelperText, HelperText, Typography } from 'shared/ui'
import { GreetingAudioBlockEditContent } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/blocks/GreetingAudioBlock'
import { Brunch } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/IVR/ui/IVRActionEditContent/Brunch/Brunch.tsx'
import styles from './styles.module.scss'
import { type IVRStore } from '../../store/IVRStore'

type IActionEditContentProps = {
  store: IVRStore
}

export const IVRActionEditContent = observer(({ store }: IActionEditContentProps) => {
  const { greetingMessageStore, addBrunch, brunches, disabledAddBrunch, brunchesError } = store

  return (
    <div className={styles.wrap}>
      <div>
        <div className={styles.header}>
          <Typography variant={'body-md-medium'} ariaLabel={'title'}>
            Greeting message
          </Typography>
          <Typography variant={'body-md-regular'} ariaLabel={'desc'} color={'tertiary'}>
            Example: For sales press 1 for support press 2
          </Typography>
        </div>
        <GreetingAudioBlockEditContent store={greetingMessageStore} />
      </div>
      <div>
        <div className={styles.header}>
          <Typography variant={'body-md-medium'} ariaLabel={'title'}>
            Menu options
          </Typography>
          <Typography variant={'body-md-regular'} ariaLabel={'desc'} color={'tertiary'}>
            Keypad options route to set destinations
          </Typography>
        </div>
        <div className={styles.brunchContent}>
          {!!brunches.length && (
            <div className={styles.brunches}>
              {brunches.map((brunch, index) => (
                <Brunch key={brunch.id} brunch={brunch} store={store} withLabel={index === 0} />
              ))}
            </div>
          )}

          <Button
            typeBtn={'contained'}
            contained={'secondary'}
            size={'medium'}
            text={'Add keypad option'}
            icon={'add'}
            onClick={addBrunch}
            disabled={disabledAddBrunch}
          />
        </div>
        {brunchesError && (
          <HelperText
            text={brunchesError}
            icon={'alertTriangleSmall'}
            variant={EnumHelperText.Error}
            paddingBlock={'6px'}
          />
        )}
      </div>
    </div>
  )
})
